var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAddemployee(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "add-employee",
    transform: "translate(-1169 -439)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_294",
    "data-name": "Ellipse 294",
    cx: 35,
    cy: 35,
    r: 35,
    transform: "translate(1169 439)",
    fill: "#004b75",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1585",
    "data-name": "Group 1585",
    transform: "translate(823.41 -120)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1145",
    "data-name": "Path 1145",
    d: "M239.28,59.327c-4.807,0-6.969-6.482-6.969-11.086,0-5.595,3.978-6.242,6.969-6.242s6.97.647,6.97,6.242C246.249,52.845,244.087,59.327,239.28,59.327Zm0-16.724c-4.4,0-6.365,1.739-6.365,5.638,0,5.041,2.434,10.482,6.365,10.482s6.365-5.441,6.365-10.482C245.645,44.343,243.682,42.6,239.28,42.6Z",
    transform: "translate(141.089 538)",
    fill: "#004c75",
    stroke: "#004c75",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1146",
    "data-name": "Path 1146",
    d: "M234.6,106.147a.3.3,0,0,1-.117-.58c.029-.012,2.9-1.258,3.231-3.8a.3.3,0,0,1,.205-.248c.133-.043,3.284-1.054,5.178.658a4.356,4.356,0,0,0,3.748,1.026c.31-.021.616-.041.918-.041a.3.3,0,1,1,0,.6c-.288,0-.58.02-.877.04a4.965,4.965,0,0,1-4.193-1.18c-1.406-1.27-3.755-.76-4.41-.583-.486,2.756-3.437,4.03-3.565,4.084a.306.306,0,0,1-.117.023Z",
    transform: "translate(139.215 482.327)",
    fill: "#004c75",
    stroke: "#004c75",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1147",
    "data-name": "Path 1147",
    d: "M129.811,305.153H100.842a.3.3,0,0,1-.3-.3c0-2.663.575-5.351,4.746-6.978,3.511-1.37,5.916-5.91,5.939-5.955a.3.3,0,0,1,.535.279c-.1.194-2.531,4.785-6.255,6.238-3.491,1.362-4.306,3.432-4.359,6.115h28.36c-.054-2.683-.869-4.752-4.359-6.115-3.724-1.453-6.155-6.057-6.256-6.252a.3.3,0,1,1,.535-.279c.024.046,2.429,4.6,5.94,5.969,4.171,1.628,4.746,4.316,4.746,6.978a.3.3,0,0,1-.3.3Z",
    transform: "translate(265.049 303.062)",
    fill: "#004c75",
    stroke: "#004c75",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1148",
    "data-name": "Path 1148",
    d: "M260.58,335.508a.3.3,0,0,1-.194-.07l-5.326-4.456a.3.3,0,1,1,.388-.463l5.132,4.294,5.149-4.294a.3.3,0,1,1,.387.463l-5.343,4.456a.3.3,0,0,1-.193.07Z",
    transform: "translate(119.789 266.649)",
    fill: "#004c75",
    stroke: "#004c75",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1149",
    "data-name": "Path 1149",
    d: "M345.1,389.577a.3.3,0,0,1-.266-.444l2.549-4.78-.852-2.468a.3.3,0,0,1,.571-.2L348,384.28a.3.3,0,0,1-.019.241l-2.61,4.9a.3.3,0,0,1-.267.16Z",
    transform: "translate(35.269 218.638)",
    fill: "#004c75",
    stroke: "#004c75",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1150",
    "data-name": "Path 1150",
    d: "M303.663,389.58a.3.3,0,0,1-.267-.16l-2.611-4.9a.3.3,0,0,1-.019-.241l.895-2.592a.3.3,0,0,1,.571.2l-.852,2.468,2.549,4.78a.3.3,0,0,1-.267.444Z",
    transform: "translate(76.706 218.634)",
    fill: "#004c75",
    stroke: "#004c75",
    strokeWidth: 0.3
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddemployee);
export default __webpack_public_path__ + "static/media/Addemployee.055e4adffc2fb860ddaa4b1bfae479a2.svg";
export { ForwardRef as ReactComponent };